import { render, staticRenderFns } from "./AssignmentTable.vue?vue&type=template&id=80650d50&scoped=true&"
import script from "./AssignmentTable.vue?vue&type=script&lang=js&"
export * from "./AssignmentTable.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTable.vue?vue&type=style&index=0&id=80650d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80650d50",
  null
  
)

export default component.exports